import React from 'react';

export type GroupBy = 'name' | 'creator_name';

interface Props {
    groupBy: string;
    setGroupBy: React.Dispatch<React.SetStateAction<GroupBy>>;
}

export default function GroupBySelect({ groupBy, setGroupBy }: Props) {
    return (
        <div>
            <select
                className="custom-select border-0 text-muted"
                name="group_by"
                value={groupBy}
                onChange={(event) => setGroupBy(event.target.value as GroupBy)}
            >
                <option value="name">Game</option>
                <option value="creator_name">Provider</option>
            </select>
        </div>
    );
}
